import TreatmentDetail from "@/pages/treatment/components/TreatmentDetail";
import RegenerativeCultureSection from "@/pages/treatment/components/RegenerativeCultureSection";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function RegenerativePage() {
  const data = getTreatmentPage("regenerative");
  if (!data) return null;
  return (
    <TreatmentDetail
      data={data}
      afterMenuSection={<RegenerativeCultureSection />}
      monitorLp={{
        title: "初めての方限定・StemSup点滴モニターのご案内",
        description:
          "初めてご来院いただく方向けのStemSup点滴モニターの内容・条件は、専用ページでご案内しています。",
        label: "StemSup点滴モニターを見る",
        url: "https://sbscl.biz/saisei/",
      }}
    />
  );
}